// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";

var internal_cleanObjectFromUndefinedRaw = (function (obj) {
    if (!obj) {
      return obj;
    }

    var newObj = {};

    Object.keys(obj).forEach(function(key) {
      if (typeof obj[key] !== 'undefined') {
        newObj[key] = obj[key];
      }
    });

    return newObj;
  });

function internal_useConvertedValue(convert, v) {
  return React.useMemo((function () {
                return Curry._1(convert, v);
              }), [v]);
}

function internal_nullableToOptionalExnHandler(x) {
  if (x !== undefined) {
    return (function (maybeExn) {
              return Curry._1(x, (maybeExn == null) ? undefined : Caml_option.some(maybeExn));
            });
  }
  
}

export {
  internal_useConvertedValue ,
  internal_cleanObjectFromUndefinedRaw ,
  internal_nullableToOptionalExnHandler ,
  
}
/* react Not a pure module */
